module.exports = __webpack_public_path__ + "static/media/fa-solid-900.4bced7c4.woff";